// extracted by mini-css-extract-plugin
export default {"content":"add-feedback-modal_content__W284D patterns_scrollBody__ksWzg"};